export const OBJECT_JOIN_CHAR = '_';
export const FILTER_SEPARATOR = ';';
export const PRICE_JOIN_CHAR = '@';
export const OBJECT_JOIN_CHAR_ENCRYPT = '`.`';
export const IS_FILTERED_URL = 'isFilteredUrl';
